import React from "react";
import "../css/messageSection.css";
import student1 from "../img/cor1.png";
import student2 from "../img/pr.png";

const MessageSection = () => {
  const messages = [
     {
      id: 2,
      name:  (
        <>
         Rev. Fr. Jefferey Gladstone. SDB
         <br/>
         <br/> Correspondent,<br />Auxilium ITI
        </>
      ),
      title: (
        <>
        </>
      ),
      img: student1,
      quote:
       "With grateful hearts we proclaim: The Lord is doing wonderful things for Auxilium ITI—holy is His name.",
      message:
       "Auxilium ITI is committed to fostering strong academics and value-based formation. We aim to prepare students who will serve the community with wisdom and a caring heart.",
    },
    {
      id: 1,
      name: (
       <>
       Rev. Fr. Lawrence Varaprasatham. SDB ,<br/>
       <br/>
          Principal,<br />Auxilium ITI
        </>
        ),
      title: (
        <>
        </>
      ),
      img: student2,
      quote:
        "Education is not the learning of facts, but the training of the mind to think.",
      message:
        "We at Auxilium ITI focus on nurturing both intellect and character. Our mission is to develop future leaders who will guide society with empathy, responsibility, and wisdom.",
    },
    
  ];

  return (
    <section className="message-section py-5">
      <div className="container text-center">
        <h2 className="fw-bold mb-4 section-title">Messages</h2>

        <div className="row g-4 justify-content-center">
          {messages.map((msg) => (
            <div key={msg.id} className="col-lg-5 col-md-6">
              <div className="message-card p-4 shadow-lg rounded-4">
                <img
                  src={msg.img}
                  alt={msg.name}
                  className="profile-img mb-3"
                />
                <h5 className="quote">"{msg.quote}"</h5>
                <p className="message-text">{msg.message}</p>
                <h5 className="name mt-3">{msg.name}</h5>
                <p className="title">{msg.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MessageSection;
